module.exports = __webpack_public_path__ + "media/images/pic/saska/elastic_bg-f3f7ed6665f8b43a2f8255aa75b464f7.png";